export enum MessageListTypeEnum {
    RECEIVED,
    SENT,
    ARCHIVED,
}
